import { connect } from 'react-redux';
import SectionNavigation from '../components/SectionNavigation';
import { DEFAULT_THEME } from '../utils/constants';

const mapStateToProps = ({ book }) => ({
  theme: book.book ? book.book.theme : DEFAULT_THEME
});

export default connect(mapStateToProps)(SectionNavigation);



// WEBPACK FOOTER //
// ./src/containers/SectionNavigationContainer.js